import React from "react";
import DOMPurify from "dompurify";


export function formatMessage(message: string): React.ReactNode {
  return message.split("\\n").map((line, index) => {
    // List item: lines starting with "- "
    const isList = line.trimStart().startsWith("- ");
    const processedLine = isList ? line.trimStart().slice(2) : line;

    // Apply formatting rules in order of complexity
    const formattedLine = processedLine
      // **bold**
      .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")

      // *italic*
      .replace(/(\*|_|_)(.*?)\1/g, "<em>$2</em>")

      // ~~strikethrough~~
      .replace(/~(.*?)~/g, "<del>$1</del>")

      // __underline__
      .replace(/__(.*?)__/g, "<u>$1</u>")

      // `:emoji:` (naive support using emojis only)
      .replace(/:smile:/g, "😄")
      .replace(/:heart:/g, "❤️")
      .replace(/:thumbsup:/g, "👍")
      // Add more emojis as needed

      // Text color: {fg:red}text{/fg}
      .replace(/\{fg:(#[0-9a-fA-F]{3,6}|[a-zA-Z]+)\}(.*?)\{\/fg\}/g, '<span style="color:$1;">$2</span>')

      // Background color: {bg:blue}text{/bg}
      .replace(/\{bg:(#[0-9a-fA-F]{3,6}|[a-zA-Z]+)\}(.*?)\{\/bg\}/g, '<span style="background-color:$1;">$2</span>')

      // ![alt](url)
      .replace(/!\[(.*?)\]\((.*?)\)/g, '<img src="$2" alt="$1" class="inline-block max-w-xs max-h-40 rounded" />')

      // [text](url)
      .replace(
        /\[(.*?)\]\((.*?)\)/g,
        '<a href="$2" class="underline text-blue-500" target="_blank" rel="noopener noreferrer">$1</a>'
      );

    if (isList) {
      return (
        <ul key={index} className="list-disc list-inside">
          <li dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(formattedLine) }} />
        </ul>
      );
    }

    return (
      <div
        key={index}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(formattedLine) }}
      />
    );
  });
}
